module.exports = __webpack_public_path__ + "static/media/svelte.6275bb59.svg";